export default __webpack_public_path__ + "static/media/Co_2020-4-1.f2647d70.png";